import React, { lazy } from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const ProjectWaves = lazy(() =>
  import("@/pages/projectWave/Index")
);
const Employee = lazy(() =>
  import("@/pages/projectWave/EmployeeWave")
);
const ReportingManager = lazy(() =>
  import("@/pages/projectWave/ReportingManagerWave")
);
const Reviewer = lazy(() =>
  import("@/pages/projectWave/Reviewer")
);
const DivisionHead = lazy(() =>
  import("@/pages/projectWave/DivisionHead")
);

const ProjectWave = [
  // {
  //   path: "projectwave",
  //   element: (
  //     <SuspenseWrapper>
  //       <ProjectWaves />
  //     </SuspenseWrapper>
  //   ),
  // },
  {
    path: "projectemployee",
    element: (
      <SuspenseWrapper>
        <Employee />
      </SuspenseWrapper>
    ),
  },
  {
    path: "projectreporting",
    element: (
      <SuspenseWrapper>
        <ReportingManager />
      </SuspenseWrapper>
    ),
  },
  {
    path: "projectreviewer",
    element: (
      <SuspenseWrapper>
        <Reviewer />
      </SuspenseWrapper>
    ),
  },
  {
    path: "projectdivision",
    element: (
      <SuspenseWrapper>
        <DivisionHead />
      </SuspenseWrapper>
    ),
  },
];

export default ProjectWave;
